export default __webpack_public_path__ + "static/media/location-empty-box.e77bcec7.svg";